"use strict";
/**
 * Italian tax identifiers, checked alike by the servers and the console (#864). Only the Italian
 * «partita IVA» for now; tax ids from abroad come later, each with its own check.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidItalianVatNumber = isValidItalianVatNumber;
exports.normalizeItalianVatNumber = normalizeItalianVatNumber;
/**
 * Whether eleven digits are a valid Italian «partita IVA» (also the form of a company's «codice
 * fiscale»): the last digit checks the first ten (digits in odd positions summed, digits in even
 * positions doubled, less 9 when over 9, then summed).
 */
function isValidItalianVatNumber(value) {
    if (!/^\d{11}$/.test(value)) {
        return false;
    }
    let sum = 0;
    for (let position = 0; position < 10; position += 1) {
        const digit = Number(value.charAt(position));
        if (position % 2 === 0) {
            sum += digit;
        }
        else {
            const doubled = digit * 2;
            sum += doubled > 9 ? doubled - 9 : doubled;
        }
    }
    return (10 - (sum % 10)) % 10 === Number(value.charAt(10));
}
/** An Italian VAT number as kept: no spaces, dots or dashes, and no «IT» prefix. */
function normalizeItalianVatNumber(value) {
    const compact = value.replace(/[\s.-]/g, '').toUpperCase();
    return compact.startsWith('IT') ? compact.slice(2) : compact;
}
//# sourceMappingURL=tax-ids.js.map